<div class="pt-3 pl-md-4" *ngIf="discountNotFound">
  <h2>Discount not found</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="loadingExistingDiscount">
  <h2>Loading Discount...</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="!myAccount.is_organization_admin">
  <h2>
    You do not have permission to
    {{ isNewDiscount ? 'create' : 'edit' }}
    discounts.
  </h2>
</div>

<div *ngIf="(serverError === null) && !discountNotFound && !loadingExistingDiscount && myAccount.is_organization_admin">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/membership-settings/discounts" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <!-- No internal navigation (yet) for discounts -->
    </ul>

    <form class="form-inline">
      <button class="btn btn-danger btn-sm ml-2"
              *ngIf="!isNewDiscount"
              [class.disabled]="isLoading()" [disabled]="isLoading()"
              type="button" (click)="handleDelete()">
        {{ loadingDelete ? 'Deleting...' : 'Delete' }}
      </button>
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="isLoading()" [disabled]="isLoading()"
              type="button" (click)="handleSubmit()">
        {{ loadingSubmit ? 'Saving...' : 'Save' }}
      </button>
    </form>
  </nav>

  <div class="capitan-sub-nav-post-content">
    <div class="alert floating-alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="pt-3 pl-md-4 mb-6">
      <h2>
        {{ isNewDiscount ? 'New Discount' : 'Edit Discount' }}
      </h2>

      <form (submit)="handleSubmit()">
        <div class="row mt-3">
          <div class="col-lg-10 col-xl-8">

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="isAutomaticSelect">Discount Type</label>
                  <select id="isAutomaticSelect" name="discount_apply_method"
                          class="custom-select"
                          [disabled]="!isNewDiscount && (discount.discount_apply_method === MembershipDiscountApplyMethod.bankTransfer)"
                          [class.disabled]="!isNewDiscount && (discount.discount_apply_method === MembershipDiscountApplyMethod.bankTransfer)"
                          [(ngModel)]="discount.discount_apply_method"
                          (ngModelChange)="handleDiscountTypeChange()">
                    <option [ngValue]="MembershipDiscountApplyMethod.code">Code</option>
                    <option [ngValue]="MembershipDiscountApplyMethod.automatic">Automatic</option>
                    <option [ngValue]="MembershipDiscountApplyMethod.referral">Referral</option>
                    <option [ngValue]="MembershipDiscountApplyMethod.cancellation">Cancellation</option>
                    <option [ngValue]="MembershipDiscountApplyMethod.bankTransfer">Bank Transfer</option>
                    <option [ngValue]="MembershipDiscountApplyMethod.freeze">Freeze</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                - "Code": The customer must enter the discount code in order to use the discount. <br>
                - "Automatic": The discount will automatically be applied to any qualifying purchases. <br>
                - "Referral": The discount will be automatically applied when another customer's referral code is entered for any qualifying purchases. <br>
                - "Cancellation": The discount will be offered to the customer when they attempt to cancel their membership. <br>
                - "Bank Transfer": The discount will automatically apply whenever a membership bill is paid via a bank transfer, and will be automatically removed if the customer later switches to a card payment method. Bank transfer discounts always apply after and in addition to any other applicable discounts. <br>
                - "Freeze": The discount will automatically apply to membership freeze fees, both recurring freeze billing and immediate (prepaid) freeze fees. <br>
                Non-Code discounts may still have a code configured for reporting purposes.
              </small>
              <div class="form-text text-danger">{{ errors.discount_apply_method }}</div>
              <div class="alert alert-info mt-2"
                   *ngIf="discount.discount_apply_method === MembershipDiscountApplyMethod.bankTransfer">
                It is your organization’s responsibility to confirm discounts for bank transfers are allowed in your jurisdiction.
              </div>
            </div>

            <div class="form-group">
              <label class="mb-1">Memberships This Discount Applies To</label>
              <span *ngIf="loadingMemberships" class="text-muted"><br> Loading...</span>
              <ng-container *ngIf="!loadingMemberships">
                <ng-container *ngIf="getPotentialDiscountRecipientMemberships() && (getPotentialDiscountRecipientMemberships().length > 0)">
                  <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                          *ngIf="!allMembershipsAreSelected()"
                          (click)="setAllMembershipsSelected()">
                    Select All
                  </button>
                  <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                          *ngIf="allMembershipsAreSelected()"
                          (click)="setNoMembershipsSelected()">
                    Deselect All
                  </button>
                  <div class="form-check" *ngFor="let membership of getPotentialDiscountRecipientMemberships()">
                    <input class="form-check-input" type="checkbox" id="membershipCheckbox{{ membership.id }}"
                           [checked]="membershipSelected(membership)"
                           (click)="toggleMembership(membership)">
                    <label class="form-check-label" for="membershipCheckbox{{ membership.id }}">
                      {{ membership.name }}
                      <span *ngIf="membership.status === MembershipStatus.draft">(Draft)</span>
                      <span *ngIf="membership.status === MembershipStatus.retired">(Retired)</span>
                    </label>
                  </div>
                </ng-container>
                <ng-container *ngIf="!(getPotentialDiscountRecipientMemberships() && (getPotentialDiscountRecipientMemberships().length > 0))">
                  <span class="text-muted d-block">No memberships configured.</span>
                </ng-container>
              </ng-container>
              <small class="form-text text-muted"
                     *ngIf="discount.discount_apply_method === MembershipDiscountApplyMethod.bankTransfer">
                Only recurring memberships may be paid via bank transfer, so prepaid memberships will not appear in this list.
              </small>
            </div>

            <div class="form-group">
              <label class="mb-1">Rolling Event Rosters This Discount Applies To</label>
              <span *ngIf="loadingRosters" class="text-muted"><br> Loading...</span>
              <ng-container *ngIf="!loadingRosters">
                <ng-container *ngIf="rosters && (rosters.length > 0)">
                  <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                          *ngIf="!allRostersAreSelected()"
                          (click)="setAllRostersSelected()">
                    Select All
                  </button>
                  <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                          *ngIf="allRostersAreSelected()"
                          (click)="setNoRostersSelected()">
                    Deselect All
                  </button>
                  <div class="form-check" *ngFor="let roster of rosters">
                    <input class="form-check-input" type="checkbox" id="rosterCheckbox{{ roster.id }}"
                           [checked]="rosterSelected(roster)"
                           (click)="toggleRoster(roster)">
                    <label class="form-check-label" for="rosterCheckbox{{ roster.id }}">
                      {{ roster.event_type_name }} - {{ roster.name }}
                    </label>
                  </div>
                </ng-container>
                <ng-container *ngIf="!(rosters && (rosters.length > 0))">
                  <span class="text-muted d-block">No rolling event rosters configured.</span>
                </ng-container>
              </ng-container>
            </div>

            <div class="form-group"
                 *ngIf="![MembershipDiscountApplyMethod.bankTransfer, MembershipDiscountApplyMethod.freeze].includes(discount.discount_apply_method)">
              <label for="isRecurringSelect">Duration</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <!--suppress TypeScriptValidateTypes -->
                  <select class="custom-select" id="isRecurringSelect" name="is_recurring"
                          *ngIf="![MembershipDiscountApplyMethod.referral, MembershipDiscountApplyMethod.cancellation].includes(discount.discount_apply_method)"
                          [(ngModel)]="discount.is_recurring"
                          (ngModelChange)="handleDiscountDurationChange()">
                    <option [ngValue]="false">Initial Payment Only</option>
                    <option [ngValue]="true">Recurring</option>
                  </select>
                  <select class="custom-select disabled" id="is_recurring_fixed_referral" name="is_recurring_fixed_referral"
                          *ngIf="discount.discount_apply_method === MembershipDiscountApplyMethod.referral"
                          [(ngModel)]="discount.is_recurring"
                          disabled
                          ngbTooltip="This discount type may only apply to the initial membership payment.">
                    <option [ngValue]="false">Initial Payment Only</option>
                  </select>
                  <select class="custom-select disabled" id="is_recurring_fixed_cancellation" name="is_recurring_fixed_cancellation"
                          *ngIf="discount.discount_apply_method === MembershipDiscountApplyMethod.cancellation"
                          [(ngModel)]="discount.is_recurring"
                          disabled
                          ngbTooltip="This discount type may only apply to a single membership payment.">
                    <option [ngValue]="false">Single Payment</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                Whether this discount applies only to the first payment, or to all payments. Only relevant for discounts applied to recurring memberships.
              </small>
              <div class="form-text text-danger">{{ errors.is_recurring }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="codeInput">
                    Code
                    <span *ngIf="discount.discount_apply_method !== MembershipDiscountApplyMethod.code">(optional)</span>
                  </label>
                  <input id="codeInput" type="text" name="code"
                         class="form-control"
                         [(ngModel)]="discount.code">
                </div>
              </div>
              <small class="form-text text-muted">
                <ng-container *ngIf="discount.discount_apply_method === MembershipDiscountApplyMethod.code">
                  This is what a customer must enter in order to apply the discount.
                </ng-container>
                <ng-container *ngIf="discount.discount_apply_method !== MembershipDiscountApplyMethod.code">
                  If provided, this will occupy the "code" column when reporting on usages of this discount.
                </ng-container>
              </small>
              <div class="form-text text-danger">{{ errors.code }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="nameInput">
                    Name
                    <span *ngIf="discount.discount_apply_method === MembershipDiscountApplyMethod.code">(optional)</span>
                  </label>
                  <input id="nameInput" type="text" name="name"
                         class="form-control"
                         [(ngModel)]="discount.name">
                </div>
              </div>
              <small class="form-text text-muted">
                <ng-container *ngIf="discount.discount_apply_method === MembershipDiscountApplyMethod.code">
                  If configured, this will be displayed in place of the discount code on the customer's receipt and in the payment table.
                </ng-container>
                <ng-container *ngIf="discount.discount_apply_method !== MembershipDiscountApplyMethod.code">
                  This will be displayed in Climber App payment and confirmation pages when the discount is used. Give this an informative name in order to ensure customers understand why they received the discount.
                </ng-container>
              </small>
              <div class="form-text text-danger">{{ errors.name }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="discountTypeSelect">Discount Value</label>
                  <select id="discountTypeSelect" name="discount_type"
                          class="custom-select"
                          [(ngModel)]="discount.discount_type"
                          [disabled]="discount.discount_apply_method === MembershipDiscountApplyMethod.referral"
                          [class.disabled]="discount.discount_apply_method === MembershipDiscountApplyMethod.referral"
                          [ngbTooltip]="(discount.discount_apply_method === MembershipDiscountApplyMethod.referral) ? 'Referral discounts may only be specified in terms of a currency amount.' : ''">
                    <option [ngValue]="MembershipDiscountType.currency">Flat Discount</option>
                    <option [ngValue]="MembershipDiscountType.percentage">Percentage</option>
                  </select>
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.discount_type }}</div>
            </div>

            <div class="form-group">
              <label for="amountInput">Amount</label>
              <div class="row">
                <div class="input-group col-lg-3 col-md-4 col-sm-5">
                  <div class="input-group-prepend" *ngIf="discount.discount_type === MembershipDiscountType.currency">
                    <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
                  </div>
                  <input id="amountInput" type="number" name="amount"
                         min="0"
                         [max]="discount.discount_type === MembershipDiscountType.currency ? '' : '100'"
                         [step]="discount.discount_type === MembershipDiscountType.currency ? '0.01' : '1'"
                         class="form-control"
                         [(ngModel)]="discount.amount">
                  <div class="input-group-append" *ngIf="discount.discount_type === MembershipDiscountType.percentage">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted" *ngIf="discount.discount_type === MembershipDiscountType.currency">
                If a discount ever exceeds the total purchase amount, the purchase will be free.
              </small>
              <div class="form-text text-danger">{{ errors.amount }}</div>
            </div>

            <div class="form-group" *ngIf="(discount.discount_type === MembershipDiscountType.percentage) && (discount.discount_apply_method !== MembershipDiscountApplyMethod.bankTransfer)">
              <label for="appliesToAddOnsSelect">Does this discount apply to add-ons?</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <select class="custom-select" id="appliesToAddOnsSelect" name="applies_to_add_ons"
                          [(ngModel)]="discount.applies_to_add_ons">
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Yes</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If "Yes", this discount will be applied to add-ons, in addition to the base fee.
              </small>
              <div class="form-text text-danger">{{ errors.applies_to_add_ons }}</div>
            </div>

            <div class="form-group" *ngIf="![MembershipDiscountApplyMethod.bankTransfer, MembershipDiscountApplyMethod.freeze].includes(discount.discount_apply_method)">
              <label for="waives_initiation_fees">Does this discount waive initiation fees?</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <select class="custom-select"
                          id="waives_initiation_fees"
                          name="waives_initiation_fees"
                          [(ngModel)]="discount.waives_initiation_fees">
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Yes</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If "Yes", initiation fees will be fully waived when this discount is applied.
              </small>
              <div class="form-text text-danger">{{ errors.waives_initiation_fees }}</div>
            </div>

            <div class="form-group"
                 *ngIf="(discount.discount_type === MembershipDiscountType.percentage) && (discount.discount_apply_method !== MembershipDiscountApplyMethod.code) && (discount.discount_apply_method !== MembershipDiscountApplyMethod.bankTransfer) && (!discount.waives_initiation_fees)">
              <label for="appliesToInitFeesSelect">Does this discount apply to initiation fees?</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <select class="custom-select" id="appliesToInitFeesSelect" name="applies_to_initiation_fees"
                          [(ngModel)]="discount.applies_to_initiation_fees">
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Yes</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If "Yes", this discount will be applied to initiation fees, in addition to the base fee.
              </small>
              <div class="form-text text-danger">{{ errors.applies_to_initiation_fees }}</div>
            </div>

            <div class="form-group"
                 *ngIf="discount.discount_apply_method !== MembershipDiscountApplyMethod.bankTransfer">
              <label class="mb-1">Availability (optional)</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <div class="row">
                    <div class="col">
                      <label for="startDateInput">Start Date</label>
                      <app-date-picker [id]="'startDateInput'"
                                       [(content)]="discount.start_date"></app-date-picker>
                      <div class="form-text text-danger">{{ errors.start_date }}</div>
                    </div>
                    <div class="col">
                      <label for="endDateInput">End Date</label>
                      <app-date-picker [id]="'endDateInput'"
                                       [(content)]="discount.end_date"></app-date-picker>
                      <div class="form-text text-danger">{{ errors.end_date }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                If provided, these dates limit when customers can use this discount. These dates are inclusive, so the discount is available from beginning of the Start Date to the end of the End Date, in the local time of your organization. In order to add a discount which is available for a single day, set both Start Date and End Date to that day.
              </small>
            </div>

            <div class="form-group"
                 *ngIf="discount.discount_apply_method !== MembershipDiscountApplyMethod.bankTransfer">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="requiresAssociationSelect">Does this discount require an association?</label>
                  <select id="requiresAssociationSelect" name="requires_association"
                          class="custom-select"
                          [(ngModel)]="discount.requires_association">
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Yes</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "Yes", then the discount may only be used for products purchased for customers in the chosen associations. For products purchased for multiple customers (for example, group memberships and multiple-participant event bookings), each customer must belong to one of the chosen associations.
              </small>
              <div class="form-text text-danger">{{ errors.requires_association }}</div>
            </div>

            <div class="form-group" *ngIf="discount.requires_association">
              <label class="mb-1">Associations Granting Discount</label>
              <span *ngIf="loadingAssociations" class="text-muted"><br> Loading...</span>
              <ng-container *ngIf="!loadingAssociations">
                <ng-container *ngIf="associations.length > 0">
                  <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                          *ngIf="!allAssociationsAreSelected()"
                          (click)="setAllAssociationsSelected()">
                    Select All
                  </button>
                  <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                          *ngIf="allAssociationsAreSelected()"
                          (click)="setNoAssociationsSelected()">
                    Deselect All
                  </button>
                  <div class="form-check" *ngFor="let association of associations">
                    <input class="form-check-input" type="checkbox" id="associationCheckbox{{ association.id }}"
                           [checked]="associationSelected(association)"
                           (click)="toggleAssociation(association)">
                    <label class="form-check-label" for="associationCheckbox{{ association.id }}">
                      {{ association.name }}
                    </label>
                  </div>
                </ng-container>
                <span *ngIf="associations.length === 0" class="d-block text-muted">
                  No associations configured
                </span>
              </ng-container>
            </div>

            <div class="form-group" *ngIf="discount.requires_association">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="requiresAllAssociationsSelect">How many of these associations must the customer belong to?</label>
                  <select id="requiresAllAssociationsSelect" name="requires_all_associations"
                          class="custom-select"
                          [(ngModel)]="discount.requires_all_associations">
                    <option [ngValue]="false">Any one of them</option>
                    <option [ngValue]="true">All of them</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "All of them", then the discount may only be used by customers who belong to every one of the associations chosen above. For products purchased for multiple customers (for example, group memberships and multiple-participant event bookings), each customer must belong to every chosen association.
              </small>
              <div class="form-text text-danger">{{ errors.requires_all_associations }}</div>
            </div>

            <div class="form-group" *ngIf="(discount.discount_apply_method !== MembershipDiscountApplyMethod.cancellation) && (discount.discount_apply_method !== MembershipDiscountApplyMethod.bankTransfer)">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="requiresMembershipSelect">
                    Does this discount require a <b>different</b> active membership?
                  </label>
                  <select id="requiresMembershipSelect" name="requires_membership"
                          class="custom-select"
                          [(ngModel)]="discount.requires_membership">
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Yes</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "Yes", then the discount may only be used for products purchased for customers with active memberships of the chosen types. For products purchased for multiple customers (for example, group memberships and multiple-participant event bookings), each customer must belong to one of the chosen memberships.
              </small>
              <div class="alert alert-info mt-1">
                Note that a membership may not count towards its own discount for the purposes of this restriction. In order to receive the discount, the customer (or customers) must have a <b>different</b> active membership of one of the chosen types.
              </div>
              <div class="form-text text-danger">{{ errors.requires_membership }}</div>
            </div>

            <div class="form-group" *ngIf="discount.requires_membership">
              <label class="mb-1">Memberships Granting Discount</label>
              <span *ngIf="loadingMemberships" class="text-muted"><br> Loading...</span>
              <ng-container *ngIf="!loadingMemberships">
                <ng-container *ngIf="memberships.length > 0">
                  <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                          *ngIf="!allRequiredMembershipsAreSelected()"
                          (click)="setAllRequiredMembershipsSelected()">
                    Select All
                  </button>
                  <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                          *ngIf="allRequiredMembershipsAreSelected()"
                          (click)="setNoRequiredMembershipsSelected()">
                    Deselect All
                  </button>
                  <div class="form-check" *ngFor="let membership of memberships">
                    <input class="form-check-input" type="checkbox" id="requiredMembershipCheckbox{{ membership.id }}"
                           [checked]="requiredMembershipSelected(membership)"
                           (click)="toggleRequiredMembership(membership)">
                    <label class="form-check-label" for="requiredMembershipCheckbox{{ membership.id }}">
                      {{ membership.name }}
                      <span *ngIf="membership.status === MembershipStatus.draft">(Draft)</span>
                      <span *ngIf="membership.status === MembershipStatus.retired">(Retired)</span>
                    </label>
                  </div>
                </ng-container>
                <span *ngIf="memberships.length === 0" class="d-block text-muted">
                  No memberships configured
                </span>
              </ng-container>
            </div>

            <div class="form-group"
                 *ngIf="discount.discount_apply_method !== MembershipDiscountApplyMethod.bankTransfer">
              <label for="maxUsesPerCustomerInput">
                Max Number of Uses Per Customer
              </label>
              <div class="row">
                <div class="col-lg-3 col-md-4">
                  <input id="maxUsesPerCustomerInput"
                         type="number" step="1" min="1"
                         name="max_number_of_uses_per_customer"
                         class="form-control"
                         [(ngModel)]="discount.max_number_of_uses_per_customer">
                </div>
              </div>
              <small class="form-text text-muted">
                If provided, this limits the number of times that a customer can use this discount. For group memberships, all members must be under the limit in order to use the discount. Leave this blank for no limit.
                <br>
                This limit applies to the members, not necessarily the customer making the purchase.
                <br>
                If a limit is configured, the discount cannot be used for unlinked purchases.
              </small>
              <div class="alert alert-info mt-1">
                Note that for recurring memberships, each bill is considered a discount "use". Once the max number of uses has been reached, the discount will no longer apply for future membership bills.
              </div>
              <div class="form-text text-danger">{{ errors.max_number_of_uses_per_customer }}</div>
            </div>

            <div class="form-group"
                 *ngIf="discount.discount_apply_method !== MembershipDiscountApplyMethod.bankTransfer">
              <label for="required_no_check_in_period_days">
                Minimum Number of Days Since Last Check-In
              </label>
              <div class="row">
                <div class="col-lg-3 col-md-4">
                  <input type="number" step="1" min="1"
                         id="required_no_check_in_period_days"
                         name="required_no_check_in_period_days"
                         class="form-control"
                         [(ngModel)]="discount.required_no_check_in_period_days">
                </div>
              </div>
              <small class="form-text text-muted">
                If provided, this discount may only be used if the customer has not checked into <b>any</b> location within your organization in the given time period. Leave this blank for no restriction.
              </small>
              <div class="form-text text-danger">{{ errors.required_no_check_in_period_days }}</div>
            </div>

            <div class="form-group"
                 *ngIf="discount.discount_apply_method !== MembershipDiscountApplyMethod.bankTransfer">
              <label>
                Required Lifetime Check-In Count
              </label>
              <div class="row">
                <div class="col-lg-3 col-md-4 mb-md-0 mb-1">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Min</span>
                    </div>
                    <input class="form-control"
                           id="min_check_in_count" name="min_check_in_count"
                           type="number" min="0" step="1"
                           [(ngModel)]="discount.min_check_in_count">
                  </div>
                </div>
                <div class="col-lg-3 col-md-4">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Max</span>
                    </div>
                    <input class="form-control"
                           id="max_check_in_count" name="max_check_in_count"
                           type="number" min="0" step="1"
                           [(ngModel)]="discount.max_check_in_count">
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                If configured, this discount may only be used for customers with a total lifetime check-in count in the provided range.
              </small>
              <div class="form-text text-danger">{{ errors.min_check_in_count }}</div>
              <div class="form-text text-danger">{{ errors.max_check_in_count }}</div>
            </div>

            <div class="form-group"
                 *ngIf="discount.discount_apply_method !== MembershipDiscountApplyMethod.bankTransfer">
              <label>
                Required Age (Years)
              </label>
              <div class="row">
                <div class="col-lg-3 col-md-4 mb-md-0 mb-1">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Min</span>
                    </div>
                    <input class="form-control"
                           id="min_age" name="min_age"
                           type="number" min="0" step="1"
                           [(ngModel)]="discount.min_age">
                  </div>
                </div>
                <div class="col-lg-3 col-md-4">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Max</span>
                    </div>
                    <input class="form-control"
                           id="max_age" name="max_age"
                           type="number" min="0" step="1"
                           [(ngModel)]="discount.max_age">
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                If configured, this discount may only be used for customers who fall in the provided age range at the time of payment.
              </small>
              <div class="form-text text-danger">{{ errors.min_age }}</div>
              <div class="form-text text-danger">{{ errors.max_age }}</div>
            </div>

            <!--suppress TypeScriptValidateTypes -->
            <div class="form-group"
                 *ngIf="![MembershipDiscountApplyMethod.bankTransfer, MembershipDiscountApplyMethod.cancellation, MembershipDiscountApplyMethod.freeze].includes(discount.discount_apply_method)">
              <label for="min_number_of_days_without_membership">
                Minimum Number of Days Without a Membership
              </label>
              <div class="row">
                <div class="col-lg-3 col-md-4">
                  <input class="form-control"
                         id="min_number_of_days_without_membership"
                         name="min_number_of_days_without_membership"
                         type="number" min="0" step="1"
                         [(ngModel)]="discount.min_number_of_days_without_membership">
                </div>
              </div>
              <small class="form-text text-muted">
                If configured, this discount may only be used for customers who do not have an active or frozen membership, and who have not had one within the provided number of days.
              </small>
              <div *ngIf="discount.is_recurring && discount.min_number_of_days_without_membership !== null"
                   class="alert alert-info mt-1">
                Since this discount is recurring, a membership's recurring payments will only receive the discount if the membership was initially purchased using it and every recurring payment since then has also received it. Once a recurring payment does not receive the discount, the membership will no longer qualify for it.
              </div>
              <div class="form-text text-danger">{{ errors.min_number_of_days_without_membership }}</div>
            </div>

            <!--suppress TypeScriptValidateTypes -->
            <div class="form-group"
                 *ngIf="discount.is_recurring && ![MembershipDiscountApplyMethod.bankTransfer, MembershipDiscountApplyMethod.cancellation].includes(discount.discount_apply_method)">
              <label for="required_active_duration_days">
                Required Active Duration
              </label>
              <div class="row">
                <div class="input-group col-lg-3 col-md-4">
                  <input class="form-control"
                         id="required_active_duration_days"
                         name="required_active_duration_days"
                         type="number" min="0" step="1"
                         [(ngModel)]="discount.required_active_duration_days">
                  <div class="input-group-append">
                    <span class="input-group-text">days</span>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                If configured, a membership must have been active for the chosen number of days before it qualifies for this discount. Time during which the membership is frozen will not count towards the number of active days.
              </small>
              <div class="form-text text-danger">{{ errors.required_active_duration_days }}</div>
            </div>

            <div class="form-group" *ngIf="showAppliesToFirstTimeMembersOnlyField()">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="applies_to_first_time_members_only">
                    Is this discount only usable by first-time members?
                  </label>
                  <select id="applies_to_first_time_members_only"
                          name="applies_to_first_time_members_only"
                          class="custom-select"
                          [(ngModel)]="discount.applies_to_first_time_members_only">
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Yes</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "Yes", then the discount may only be used by members who have not previously held a membership.
              </small>
              <div *ngIf="discount.is_recurring && discount.applies_to_first_time_members_only"
                   class="alert alert-info mt-1">
                Since this discount is recurring, a membership's recurring payments will only receive the discount if the membership was initially purchased using it and every recurring payment since then has also received it. Once a recurring payment does not receive the discount, the membership will no longer qualify for it.
              </div>
              <div class="form-text text-danger">{{ errors.applies_to_first_time_members_only }}</div>
            </div>

            <div class="form-group" *ngIf="![MembershipDiscountApplyMethod.cancellation, MembershipDiscountApplyMethod.freeze].includes(discount.discount_apply_method)">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="can_be_used_with_upfront_payments">
                    Can this discount be applied when multiple payment periods are paid up front?
                  </label>
                  <select id="can_be_used_with_upfront_payments"
                          name="can_be_used_with_upfront_payments"
                          class="custom-select"
                          [(ngModel)]="discount.can_be_used_with_upfront_payments">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "No", this discount will not apply to a membership's initial purchase when the member is paying for multiple periods up front. Future recurring payments for the membership are not affected.
              </small>
              <div class="form-text text-danger">{{ errors.can_be_used_with_upfront_payments }}</div>
            </div>

            <div class="form-group"
                 *ngIf="discount.discount_apply_method === MembershipDiscountApplyMethod.referral">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="referrer_must_have_active_membership">
                    Is the referrer required to have an active membership?
                  </label>
                  <select id="referrer_must_have_active_membership"
                          name="referrer_must_have_active_membership"
                          class="custom-select"
                          [(ngModel)]="discount.referrer_must_have_active_membership">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "Yes", then the discount will only be applied if the referrer has an active membership.
              </small>
              <div class="form-text text-danger">{{ errors.referrer_must_have_active_membership }}</div>
            </div>

            <div class="form-group"
                 *ngIf="discount.discount_apply_method === MembershipDiscountApplyMethod.referral">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="may_combine_with_other_discounts">
                    Can this discount be applied in addition to another <span class="text-nowrap">(non-referral)</span> discount?
                  </label>
                  <select id="may_combine_with_other_discounts"
                          name="may_combine_with_other_discounts"
                          class="custom-select"
                          [(ngModel)]="discount.may_combine_with_other_discounts">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "No", then this referral discount will not be applied if the membership has already received another discount (such as an automatic or code discount).
              </small>
              <div class="form-text text-danger">{{ errors.referrer_must_have_active_membership }}</div>
            </div>

            <ng-container *ngIf="discount.discount_apply_method === MembershipDiscountApplyMethod.referral">
              <label><b>Discount Referrer Credit</b></label>

              <div class="alert alert-info">
                The following fields configure the credit granted to the discount referrer when their referral code is used to purchase a membership. The credit is only granted once the membership payment completes.
              </div>

              <div class="indented-subsection">

                <div class="form-group">
                  <label for="referrerCreditAmountInput">Referrer Credit Amount</label>
                  <div class="row">
                    <div class="input-group col-lg-3 col-md-4 col-sm-5">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
                      </div>
                      <input id="referrerCreditAmountInput" type="number" name="referrer_credit_amount"
                             min="0" step="0.01"
                             class="form-control"
                             [(ngModel)]="discount.referrer_credit_amount">
                    </div>
                  </div>
                  <div class="form-text text-danger">{{ errors.referrer_credit_amount }}</div>
                </div>

                <div class="form-group">
                  <label for="max_number_of_referrer_credits_per_month">
                    Max # of Referrer Credits Applied Per Month
                  </label>
                  <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-5">
                      <input id="max_number_of_referrer_credits_per_month"
                             name="max_number_of_referrer_credits_per_month"
                             type="number"
                             min="1" step="1"
                             class="form-control"
                             [(ngModel)]="discount.max_number_of_referrer_credits_per_month">
                    </div>
                  </div>
                  <small class="form-text text-muted">
                    If provided, this will limit the number of credits that a customer can receive in a calendar month. Any referrals above this limit will not grant a credit. Leave this blank for no limit.
                  </small>
                  <div class="form-text text-danger">{{ errors.max_number_of_referrer_credits_per_month }}</div>
                </div>

                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input"
                           id="referrer_credit_only_applies_to_recurring_payments"
                           name="referrer_credit_only_applies_to_recurring_payments"
                           [(ngModel)]="discount.referrer_credit_only_applies_to_recurring_payments">
                    <label class="custom-control-label checkbox-label"
                           for="referrer_credit_only_applies_to_recurring_payments">
                      Referrer credits may only be used for recurring membership payments
                    </label>
                  </div>
                  <div class="form-text text-danger">{{ errors.referrer_credit_only_applies_to_recurring_payments }}</div>
                </div>

              </div>

            </ng-container>

            <ng-container *ngIf="discount.discount_apply_method === MembershipDiscountApplyMethod.cancellation">

              <div class="form-group">
                <label>Customer Offer Message</label>
                <a href="#" (click)="$event.preventDefault();openCancellationDiscountOfferPreviewModal();" class="float-right">
                  Preview Offer
                </a>
                <app-markdown-editor [id]="'customer_message'"
                                     [(content)]="discount.customer_message"
                                     [shortEditor]="true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This text is shown to the customer when the discount is offered to them. Use this to explain to the customer why they are receiving this offer. For example, "you have been a loyal customer and we would hate to see you leave."
                </small>
                <div class="form-text text-danger">{{ errors.customer_message }}</div>
              </div>

              <div class="form-group">
                <label class="mb-0">How long must the customer have had the membership in order to receive the offer? (optional)</label>
                <div class="row">
                  <div class="col-6">
                    <label for="minimum_duration_before_offer_months" class="text-small mb-1">Months</label>
                    <input type="number" class="form-control"
                           id="minimum_duration_before_offer_months"
                           name="minimum_duration_before_offer_months"
                           min="0" step="1"
                           [(ngModel)]="discount.minimum_duration_before_offer_months">
                    <div class="form-text text-danger">{{ errors.minimum_duration_before_offer_months }}</div>
                  </div>
                  <div class="col-6">
                    <label for="minimum_duration_before_offer_days" class="text-small mb-1">Days</label>
                    <input type="number" class="form-control"
                           id="minimum_duration_before_offer_days"
                           name="minimum_duration_before_offer_days"
                           min="0" step="1"
                           [(ngModel)]="discount.minimum_duration_before_offer_days">
                    <div class="form-text text-danger">{{ errors.minimum_duration_before_offer_days }}</div>
                  </div>
                </div>
                <small class="form-text text-muted">
                  If both months and days are provided, they will be added together to determine the minimum time before offer. Leave both blank in order to have no restriction.
                </small>
              </div>

            </ng-container>

            <ng-container *ngIf="discount.discount_apply_method === MembershipDiscountApplyMethod.bankTransfer">

              <div class="form-group">
                <label>Purchase Alert Message (optional)</label>
                <app-markdown-editor [id]="'purchase_alert_message'"
                                     [(content)]="discount.purchase_alert_message"
                                     [shortEditor]="true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This alert will be shown before a customer purchases a membership which is eligible for this bank transfer discount. The alert is shown before the customer selects their payment method, so it may be used to explain the discount that they will receive if they choose to pay via bank transfer.
                </small>
                <div class="form-text text-danger">{{ errors.purchase_alert_message }}</div>
              </div>

              <div class="form-group">
                <label>Purchase Terms and Conditions (optional)</label>
                <app-markdown-editor [id]="'purchase_terms_and_conditions'"
                                     [(content)]="discount.purchase_terms_and_conditions"
                                     [shortEditor]="true"></app-markdown-editor>
                <small class="form-text text-muted">
                  These terms and conditions must be agreed to before a customer purchases a membership which is eligible for this bank transfer discount. The terms are shown before the customer selects their payment method, so they may be used to ensure the customer understands the discount policy before they make the purchase. This is shown in addition to any terms and conditions configured for the membership type.
                </small>
                <div class="form-text text-danger">{{ errors.purchase_terms_and_conditions }}</div>
              </div>

              <div class="form-group">
                <label>Change Payment Method Alert Message (optional)</label>
                <app-markdown-editor [id]="'change_payment_method_alert_message'"
                                     [(content)]="discount.change_payment_method_alert_message"
                                     [shortEditor]="true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This alert will be shown before a customer changes the payment method of a membership which is eligible for this bank transfer discount. The alert may be used to explain how their fees may change if they move between a card and a bank transfer payment method.
                </small>
                <div class="form-text text-danger">{{ errors.change_payment_method_alert_message }}</div>
              </div>

              <div class="form-group">
                <label>Change Payment Method Terms and Conditions (optional)</label>
                <app-markdown-editor [id]="'change_payment_method_terms_and_conditions'"
                                     [(content)]="discount.change_payment_method_terms_and_conditions"
                                     [shortEditor]="true"></app-markdown-editor>
                <small class="form-text text-muted">
                  These terms and conditions must be agreed to before a customer changes the payment method of a membership which is eligible for this bank transfer discount. The terms may be used to ensure the customer understands how their fees may change if they move between a card and a bank transfer payment method.
                </small>
                <div class="form-text text-danger">{{ errors.change_payment_method_terms_and_conditions }}</div>
              </div>

            </ng-container>

            <app-last-updated-by-footer
              [updatedAt]="discount.updated_at"
              [firstName]="discount.last_updated_by_first_name"
              [lastName]="discount.last_updated_by_last_name"
              [email]="discount.last_updated_by_email"
            ></app-last-updated-by-footer>

          </div>
        </div>
      </form>
    </div>
  </div>
</div>
